import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation as baseUseTranslation } from 'react-i18next'
import { userSlice, contentSlice } from '../reducers'
import { updateI18nLanguage } from '../services/i18n'

const useTranslation = (namespace, ...args) => {
  // Based on the namespace, use the appropriate language selector
  // Might require refactoring if we add more namespaces - Currently only skill_bite and content are supported.
  const language = useSelector(namespace === 'skill_bite' ? userSlice.selectors.selectSkillBiteLanguage : contentSlice.selectors.selectLanguageCode)

  const response = baseUseTranslation(namespace, ...args)

  useEffect(() => {
    const setLanguage = async (language) => {
      await updateI18nLanguage(language)
    }

    setLanguage(language)
  }, [language])

  return response
}

export default useTranslation
